import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  submitPaymentContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px',
    backgroundColor: theme.evPalette.charcoal[100],
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      padding: '16px 24px',
      gap: '16px',
    },
  },
  paymentContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '0px',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      gap: '16px',
    },
  },
  paymentOptionDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    borderRadius: '0px',
    gap: '24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    '@media (min-width: 640px)': {
      borderBottom: '0px',
      borderRadius: '4px',
    },
  },
  paymentOptionValues: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    backgroundColor: theme.evPalette.charcoal[100],
    gap: '24px',
    borderRadius: '4px',
  },
  optionValue: {
    display: 'flex',
    gap: '48px',
  },
  amountValue: {
    display: 'flex',
    gap: '24px',
  },
  paymentInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px',
    borderRadius: '0px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    '@media (min-width: 640px)': {
      borderBottom: '0px',
      borderRadius: '4px',
    },
  },
  paymentSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    gap: '24px',
    borderRadius: '0px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: '430px',
      borderRadius: '4px',
    },
  },
  paymentSummaryAmountContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paymentSummaryTotalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 0px',
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
  },
  optionKeyText: {
    minWidth: '128px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '15px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  purchaseOrderLabel: {
    fontSize: '16px',
    fontWeight: '600',
    color: theme.evPalette.charcoal[800],
    marginBottom: '8px',
  },
  purchaseOrderInput: {
    width: '100%',
    height: '48px',
    padding: '0px',
    fontSize: '14px',
    borderRadius: '4px',
    '@media (min-width: 640px)': {
      maxWidth: '432px',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  infoAlert: {
    maxWidth: '782px',
    borderRadius: '4px',
    alignItems: 'center',
    '&>.myev-MuiAlert-icon': {
      color: theme.evPalette.ocean[600],
    },
  },
  submitPaymentSuccessContainer: {
    padding: '0px',
    display: 'flex',
    flex: 1,
    '@media (min-width: 640px)': {
      padding: '16px 24px',
      flex: '0',
    },
  },
  submitPaymentSuccessPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    gap: '24px',
    padding: '24px ',
    '@media (min-width: 640px)': {
      padding: '16px 24px',
    },
  },
  successPagePaymentOptionValues: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  successPageOptionValue: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    gap: '8px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  successPageOptionKeyText: {
    minWidth: '128px',
    '@media (min-width: 640px)': {
      alignSelf: 'center',
    },
  },
  button: {
    height: '44px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
}));
